// Cart state management using sessionStorage and cookies

function generateRandomString(length) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    return Array.from({ length }, () => chars.charAt(Math.floor(Math.random() * chars.length))).join('');
}

function getCartItems() {
    return JSON.parse(sessionStorage.getItem('temp_cart_items') || '[]');
}

function saveCartItems(cartItems) {
    sessionStorage.setItem('temp_cart_items', JSON.stringify(cartItems));

    const expires = new Date(Date.now() + (30 * 24 * 60 * 60 * 1000)).toUTCString();
    document.cookie = `temp_cart_items=${JSON.stringify(cartItems)}; expires=${expires}; path=/`;

    updateCartIndicator();
}

async function addToTempCart(itemCode, qtyToAdd) {
    // Ensure qtyToAdd is at least 1
    qtyToAdd = Math.max(1, qtyToAdd);

    if (!sessionStorage.getItem('temp_cart_id')) {
        sessionStorage.setItem('temp_cart_id', generateRandomString(10));
    }

    const cartItems = getCartItems();
    const existing = cartItems.find(item => item.item_code === itemCode);
    const currentQty = existing ? existing.qty : 0;
    const newQty = currentQty + qtyToAdd;

    try {
        const productInfo = await getProductInfo(itemCode);
        const stockQty = productInfo.stock_qty;

        if (newQty > stockQty) {
            frappe.show_alert({ message: `Cannot add more. Only ${stockQty} of ${productInfo.item_name || itemCode} in stock.`, indicator: 'orange' }, 5);
            // Return the current quantity in cart if stock limit is reached
            return Promise.reject({ currentQty: currentQty, stockQty: stockQty, message: 'Stock limit reached' }); 
        }

        if (existing) {
            existing.qty = newQty;
        } else {
            cartItems.push({ item_code: itemCode, qty: newQty });
        }

        saveCartItems(cartItems);
        frappe.show_alert({ message: `${productInfo.item_name || itemCode} added to cart.`, indicator: 'green' }, 3);
        return Promise.resolve(); // Resolve successfully

    } catch (error) {
        console.error("Error adding to cart:", error);
        frappe.show_alert({ message: 'Error checking stock or adding item.', indicator: 'red' }, 5);
        return Promise.reject(error); // Propagate error
    }
}

async function updateCartItem(itemCode, newQty) {
    newQty = Math.max(0, newQty); // Allow setting quantity to 0 to trigger removal

    if (newQty < 1) {
        // Remove item if quantity is less than 1
        return removeCartItem(itemCode);
    }

    try {
        const productInfo = await getProductInfo(itemCode);
        const stockQty = productInfo.stock_qty;

        if (newQty > stockQty) {
             frappe.show_alert({ message: `Cannot update. Only ${stockQty} of ${productInfo.item_name || itemCode} in stock.`, indicator: 'orange' }, 5);
             return Promise.reject({ stockQty: stockQty, message: 'Stock limit reached' });
        }

        const cartItems = getCartItems();
        const item = cartItems.find(i => i.item_code === itemCode);
        if (!item) {
            return Promise.reject('Item not found in cart');
        }
        
        item.qty = newQty;
        saveCartItems(cartItems);
        // Optionally add a success message here if needed
        // frappe.show_alert({ message: 'Cart updated.', indicator: 'green' }, 2);
        return Promise.resolve(); // Resolve successfully

    } catch (error) {
         console.error("Error updating cart item:", error);
         frappe.show_alert({ message: 'Error checking stock or updating item.', indicator: 'red' }, 5);
         return Promise.reject(error); // Propagate error
    }
}

function removeCartItem(itemCode) {
    return new Promise((resolve, reject) => {
        const currentItems = getCartItems();
        const updated = currentItems.filter(i => i.item_code !== itemCode);
        if (updated.length === currentItems.length) {
            // Item wasn't found, maybe already removed
            // Resolve peacefully or reject depending on desired behavior
            return resolve(); 
            // return reject('Item not found to remove'); 
        }
        saveCartItems(updated);
        frappe.show_alert({ message: 'Item removed from cart.', indicator: 'info' }, 3);
        resolve();
    });
}

function clearCart() {
    sessionStorage.removeItem('temp_cart_items');
    sessionStorage.removeItem('temp_cart_id');
    document.cookie = 'temp_cart_items=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    updateCartIndicator();
}

// Caching product info
const productCache = {};

function getProductInfo(variantCode) {
    return new Promise((resolve, reject) => {
        if (productCache[variantCode]) {
             //console.log(`Cache hit for ${variantCode}`);
             return resolve(productCache[variantCode]);
        }
        //console.log(`Cache miss for ${variantCode}, fetching...`);
        frappe.call({
            method: 'noctis_ecommerce.api.shop_utils.get_product_info',
            args: { variant_code: variantCode }, // Ensure backend expects variant_code
            callback: r => {
                if (r.message) {
                    // Add item_name if missing from get_product_info response for consistency
                    if (!r.message.item_name) {
                        // Attempt to get from frappe cache or fallback
                        const item_doc = frappe.get_doc(':Item', variantCode);
                        r.message.item_name = item_doc ? item_doc.item_name : variantCode;
                    }
                    productCache[variantCode] = r.message;
                  //  console.log(`Cached data for ${variantCode}:`, r.message);
                    resolve(r.message);
                } else {
                    console.error(`No product data returned for ${variantCode}`);
                    reject('No product data');
                }
            },
            error: (xhr, status, err) => {
                console.error(`Error fetching product info for ${variantCode}:`, status, err);
                reject(`${status}: ${err}`)
            }
        });
    });
}

function updateCartIndicator() {
    const cartItems = getCartItems();
    const cartCount = cartItems.reduce((sum, item) => sum + item.qty, 0); // Sum quantities
    const uniqueItemCount = cartItems.length; // Count unique items

    document.querySelectorAll('.cart-indicator').forEach(el => el.style.display = uniqueItemCount > 0 ? 'inline-block' : 'none');
    document.querySelectorAll('.cart-count').forEach(el => el.textContent = cartCount); // Show total quantity
    addCartLinkToHeader();
}

function addCartLinkToHeader() {
    const nav = document.querySelector('.navbar-left');
    if (!nav || document.querySelector('.cart-link')) return;

    const cartLink = document.createElement('a');
    cartLink.href = '/checkout';
    cartLink.className = 'cart-link nav-link';
    cartLink.innerHTML = `
        <div class="d-flex align-items-center">
            <i class="fa fa-shopping-cart me-1"></i>
            <span>Bag</span>
            <span class="cart-indicator ms-1" style="display: none;">
                <span class="cart-count badge bg-danger">0</span>
            </span>
        </div>`;

    const li = document.createElement('li');
    li.className = 'nav-item';
    li.appendChild(cartLink);
    nav.appendChild(li);
}

// Expose cart functions to the global scope
// This is needed to make them accessible across different bundles
window.addToTempCart = addToTempCart;
window.updateCartItem = updateCartItem;
window.removeCartItem = removeCartItem;
window.getCartItems = getCartItems;
window.getProductInfo = getProductInfo;